import React from "react";
import classnames from "classnames";
import { iconPromo, iconLinkCheckmark } from "assets";
import { Spinner } from "components/UI/Loading";
import Selectors from "selectors";
import Actions from "actions";
import { useSelector } from "react-redux";
import styled from "@emotion/styled";

const StyledImg = styled.img`
  position: absolute;
  padding-right: 9px;
  height: 14px;
`;

export default function PromoCode({ setPromoCode, handleChange, promoCode }) {
  const isLoadingPromoCode = useSelector(
    Selectors.createLoadingSelector([Actions.VALIDATE_PROMO_CODE_REQUEST])
  );
  return (
    <div className={classnames("flex justify-end relative", "w-full")}>
      <img
        src={iconPromo.default}
        alt=""
        className="h-12 rounded-r-none rounded-l-full focus:outline-none shadow"
      />
      <input
        name="promoCode"
        className="appearance-none leading-tight px-3 text-gray-600 w-full h-12 border-none outline-none focus:outline-none rounded-r-full shadow"
        onChange={(e) => {
          handleChange(e);
        }}
        placeholder="Enter promo code…"
        value={promoCode}
      />
      {isLoadingPromoCode ? (
        <div className="absolute h-10 self-center right-3 flex items-center mr-3">
          <Spinner type="ThreeDots" height={20} width={20} />
        </div>
      ) : (
        promoCode ? <StyledImg
          src={iconLinkCheckmark.default}
          alt=""
          className="h-10 self-center"
        /> : null
      )}
    </div>
  );
}
